import { IconName } from 'ui/components/'

import { BaseItemTypes, ItemColors, ItemType } from './types'

export type TableActionsItem =
  | {
      type: ItemType
      title: string

      url?: string
      onClick?: () => void
    }
  | {
      type: BaseItemTypes

      url?: string
      onClick?: () => void
    }

export interface TableActionsProps {
  items: TableActionsItem[]
  dataQaAttribute?: string
}

export type TableActionsWithIconsItem =
  | (TableActionsItem & {
      type: ItemType
      icon: IconName
      color: ItemColors
    })
  | (TableActionsItem & {
      type: BaseItemTypes
    })

export interface TableActionsWithIconsProps {
  items: TableActionsWithIconsItem[]
  dataQaAttribute?: string
}
